import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DEFAULT_CONTENT, mergeContent } from "@/lib/content";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const imgUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

const Ctx = createContext(DEFAULT_CONTENT);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  useEffect(() => {
    api.get("/content").then((r) => setContent(mergeContent(DEFAULT_CONTENT, r.data))).catch(() => {});
  }, []);
  return <Ctx.Provider value={content}>{children}</Ctx.Provider>;
}

export const useContent = () => useContext(Ctx);
